import BaseServer from './BaseServer'
import getConfig from 'next/config';
const { publicRuntimeConfig } = getConfig();

export default class APIServer extends BaseServer { 
	constructor(auth = null) { 
		super(publicRuntimeConfig.apiUrl, auth)
	}
}